// extracted by mini-css-extract-plugin
module.exports = {"container":"Payment_container__3jGgK"};